:host {
  display: block;
  max-width: 100%;
}

gz-dropdown-menu {
  height: 32px;
}

gz-dropdown-menu[open]::part(dropdown-button) {
  background-color: var(--chart-100-pressed);
}

.wrapper {
  padding: 2px;
}

gz-slider {
  width: 500px;
  background: var(--white-layout-301-level-0-elevation);
}
